const positiveInteger = (value) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

const pageFromLegacyUrl = (url) => {
  if (typeof url !== "string" || !url) return null;

  try {
    return positiveInteger(new URL(url, "https://client-history.invalid").searchParams.get("page"));
  } catch (_error) {
    return null;
  }
};

export const buildClientHistoryListRequest = (route, values = {}) => {
  const page = positiveInteger(values.page) || pageFromLegacyUrl(values.next_page_url);
  const limit = positiveInteger(values.limit) || positiveInteger(queryValueFromLegacyUrl(values.next_page_url, "limit"));
  const clientId = positiveInteger(values.client_id);
  const id = positiveInteger(values.id);
  const body = { pagination: !id };

  if (clientId) body.client_id = clientId;
  if (id) body.id = id;
  if (limit) body.limit = limit;

  return { url: `${route}${page ? `?page=${page}` : ""}`, body };
};

const queryValueFromLegacyUrl = (url, name) => {
  if (typeof url !== "string" || !url) return null;

  try {
    return new URL(url, "https://client-history.invalid").searchParams.get(name);
  } catch (_error) {
    return null;
  }
};
